import { useQuery } from "@tanstack/react-query";

import { api, call } from "@/core/api/client";
import { ENDPOINTS } from "@/core/api/endpoints";
import { QUERY_KEYS } from "@/core/api/query-client";

/** The platform's numbers right now (also the Users page's total). */
export function useAdminOverview() {
  return useQuery({
    queryKey: QUERY_KEYS.overview,
    queryFn: async () => (await call(api.GET(ENDPOINTS.adminOverview))).data,
    refetchInterval: 60_000,
  });
}
